import { getClassNamespace } from '@blueprintjs/core/lib/esm/common/classes';

const ns = getClassNamespace();

export const getIntentClassName = (intent: string) => `${ns}-intent-${intent}`;
